<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Facturación</h6>
                </div>
                <div class="col-md-10">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                        <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                        type="text"
                        class="form-control"
                        v-model="searchTerm"
                        :placeholder="
                            this.$store.state.isRTL ? 'أكتب هنا...' : 'Buscar...'
                        "
                        />
                    </div>
                </div>
                <!-- <div class="col-md-2 ">
                    <argon-button
                    class="mt-0"
                    color="success"
                    fullWidth
                    size="xs"
                    @click="toCreate"
                    >Nueva Solicitud</argon-button> 
                </div> -->
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Código</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Nombres y Apellidos</th>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >Documento de identidad</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Plazo</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Periodo</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Inicio del crédito</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Fin del crédito</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Saldo</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Estado</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Acciones
                            </th>
                        
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(
                            {
                                id,
                                document,
                                name,
                                term,
                                condition_level,
                                init_date,
                                end_date,
                                balance,
                                state
                            },
                            index
                            ) in filteredRows"
                            :key="index"
                        > 
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{ id }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div>
                                    
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{name}}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ document }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ term }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0" v-if="condition_level=='1'">Diario</p>
                                <p class="text-xs font-weight-bold mb-0" v-if="condition_level=='4'">Mensual</p>
                            </td>

                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{init_date}}</p>

                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ end_date }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ balance }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0" v-if="state=='1'">Vigente</p>
                                <p class="text-xs font-weight-bold mb-0" v-if="state=='2'">Saneado</p>
                            </td>
                            <td class="align-middle">
                            <!-- <a
                                :href="'edit-client/'+id"
                                class="btn bg-success mr-2"
                                data-toggle="tooltip"
                                data-original-title="Edit user"
                            ><i class="fa fa-edit text-white text-sm opacity-10"></i></a> -->
                            <a
                                :href="'view-loan/'+id"
                                class="btn bg-success mx-2"
                                data-toggle="tooltip"
                                data-original-title="Ver crédito"
                            ><i class="fa fa-folder text-white text-sm opacity-10"></i></a>
                           <!--  <a
                                :href="'create-order/'+id"
                                class="btn bg-success "
                                data-toggle="tooltip"
                                data-original-title="Edit user"
                            ><i class="fa fa-folder-plus text-white text-sm opacity-10"></i></a> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
  
<script>
//import ArgonButton from "@/components/ArgonButton.vue";

export default {
    name: "patients-table",
    props: {
        clients:Array,
    },
    data(){
        return({
            searchTerm:null,
            clientsList: []
        })
    },
    components: { /*ArgonButton*/ },
    computed:{
        filteredRows(){
            if(!this.searchTerm){
                return this.clients;
            }else{
                return this.clients.filter(item => {
                    let firstName=item.name.toString().toLowerCase();
                    let documentNat=item.document.toString().toLowerCase();
                    return firstName.includes(this.searchTerm)||documentNat.includes(this.searchTerm)
                })
            }
        }
    },
    methods:{
        toCreate(){
            this.$router.push('/create-client')
        },
    },
};
</script>
  